import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function AnnouncementBar() {
  const [visible, setVisible] = useState(true);
  return <AnimatePresence data-id="element-15">
      {visible && <motion.div initial={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="bg-gradient-to-r from-[#0084A8] to-[#00C9B1] relative overflow-hidden" data-id="element-16">
          <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center text-sm md:text-base font-medium text-white" data-id="element-17">
            <span className="text-[#0D1A35]" data-id="element-18">
              🔥 Launch Week Only: Full bundle $330 value →{' '}
              <span className="font-bold text-[#FFFFFF]" data-id="element-19">$59.99 today</span>.
              Ends Sunday.
            </span>
            <button onClick={() => setVisible(false)} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/20 transition-colors" aria-label="Dismiss announcement" data-id="element-20">
              <XIcon className="w-4 h-4" data-id="element-21" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}